module.exports = __webpack_public_path__ + "static/media/7D.9556bcba.svg";